import { getBucketForFlag } from "./featureFlagConstants";

// Existing modules in public/resources/module-data.js. Keep absent modules
// unlinked instead of guessing a destination or using the marketing website.
const GUIDE_MODULES = new Set([
  "scheduling", "forecasting", "labor_modeling", "labor_compliance",
  "live_action", "task_management", "logbook", "maintenance", "team_management",
  "team_chat", "training", "engagement", "contests", "boards", "documents",
  "ai_assistant", "reporting", "time_attendance", "mobile_app",
]);

export function getFeatureGuide(flag) {
  const bucket = getBucketForFlag(flag);
  if (!bucket || !GUIDE_MODULES.has(bucket.key)) return null;
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return { title: bucket.title, url: `${base}/resources/module.html?module=${encodeURIComponent(bucket.key)}` };
}
